module.exports = __webpack_public_path__ + "media/images/icon-svg/hamburger-3cb18bc026e076454ad4c148dd3ca98d.svg";